// Fallback when the game has no saved team colors (utils/teamColors)
export const TEAM_DISPLAY = {
  // `textColor` is readable on top of `color` (e.g. batting order badges)
  away: { color: "#FFB81C", textColor: "#000000" },
  home: { color: "#0066CC", textColor: "#FFFFFF" },
} as const;

export type TeamSide = keyof typeof TEAM_DISPLAY;
